import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { paths } from 'src/routes/paths';

import MainLayout from 'src/layouts/main';
import { AuthGuard } from 'src/auth/guard';
import SimpleLayout from 'src/layouts/simple';

import { SplashScreen } from 'src/components/loading-screen';

// Knowledge Base
const KnowledgeBasePage = lazy(() => import('src/pages/knowledge-base'));
// Pricing
const PricingPage = lazy(() => import('src/pages/pricing'));
// Payment Success
const PaymentSuccessPage = lazy(() => import('src/pages/payment-success'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <MainLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [
      { path: 'pricing', element: <PricingPage /> },
    ],
  },
  // Help center: its own page, named in the header, with a way back to the app
  {
    element: (
      <AuthGuard>
        <SimpleLayout showAccount title="Help center" backTo={paths.dashboard.root}>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </SimpleLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'knowledge-base', element: <KnowledgeBasePage /> },
      { path: 'knowledge-base/:articleId', element: <KnowledgeBasePage /> },
    ],
  },
  // Payment success (SimpleLayout with Account)
  {
    element: (
      <AuthGuard>
        <SimpleLayout showAccount>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </SimpleLayout>
      </AuthGuard>
    ),
    children: [
      { path: 'payment-success', element: <PaymentSuccessPage /> },
    ],
  },
];
